import {
  type BillingProfileDomainSelectModel,
  BillingProfileId,
  NetsuiteId,
  OrganizationId,
} from '@mntn-dev/domain-types'

import { MockModel } from './mock-model.ts'

export const MockBillingProfile = MockModel<BillingProfileDomainSelectModel>(
  ({
    billingProfileId = BillingProfileId(),
    name = 'Organization Billing Profile',
    organizationId = OrganizationId(),
    netsuiteId = NetsuiteId(),
    billingSchedule = '100_up_front',
    currency = 'USD',
    invoiceTerms = 'none',
    ams = false,
    hasBillingAddress = false,
    billingContactEmail,
    ubsEntityId,
    billingServiceMethodId,
  }) =>
    ({
      billingProfileId,
      name,
      organizationId,
      netsuiteId,
      billingSchedule,
      currency,
      invoiceTerms,
      ams,
      hasBillingAddress,
      billingContactEmail,
      ubsEntityId,
      billingServiceMethodId,
    }) satisfies BillingProfileDomainSelectModel
)
